<button class="shortcut-menu__button" (click)="openTicketsDialog($event)">
  <svg-icon src="assets/images/icons/notification.svg"></svg-icon>
  <span>{{ "ShortcutMenu.Tickets" | translate }}</span>
  <div [ngClass]="{ red: messages().length > 0 }" class="shortcut-menu__badge">{{ messages().length }}</div>
</button>
